import React from 'react';
import { FiPhoneCall, FiCalendar, FiMessageSquare, FiGlobe } from 'react-icons/fi';
import Hero from '../../components/sections/Hero';
import AuditForm from '../../components/sections/AuditForm';
import SEO from '../../components/common/SEO';
import SafeIcon from '../../components/common/SafeIcon';
import { servicesData } from '../../data/services';

const VoiceAutomation = () => {
  const data = servicesData['voice-automation'];
  
  const automationFeatures = [
    {
      title: "24/7 Virtual Receptionist",
      desc: "An intelligent voice agent that answers every call on the first ring—handling inquiries, qualifying leads, and eliminating the 'Missed Call Tax.'",
      icon: FiPhoneCall
    },
    {
      title: "Automated Booking Engine",
      desc: "Our AI doesn’t just take messages; it books appointments directly into your calendar based on your real-time availability.",
      icon: FiCalendar
    },
    {
      title: "AI Missed-Call Text-Back",
      desc: "If a call is missed, our system instantly texts the lead. 78% of customers buy from the first business that responds.",
      icon: FiMessageSquare
    },
    {
      title: "Bilingual Support",
      desc: "Seamlessly assist clients in both English and French, expanding your reach across Alberta’s diverse professional landscape.",
      icon: FiGlobe
    }
  ];

  return (
    <>
      <SEO title={`${data.title} | Alberta SEO Pro`} description={data.description} />
      <Hero 
        title="Capture Every Opportunity, 24/7" 
        subtitle={data.longDesc} 
      />
      
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-orange-50 rounded-3xl p-8 md:p-12 mb-20 border border-orange-100">
            <div className="max-w-3xl">
              <h2 className="text-3xl font-bold text-slate-900 mb-6">Stop Losing Leads to the "Missed Call Tax"</h2>
              <p className="text-lg text-slate-700 mb-8">
                In Alberta's competitive home services market, a missed call is a gift to your competitors. 
                Our Conversational AI ensures that every prospect is greeted, qualified, and booked—even while you're on a job site or sleeping.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="bg-white px-6 py-4 rounded-xl shadow-sm border border-orange-200">
                  <span className="block text-3xl font-bold text-orange-600">62%</span>
                  <span className="text-sm text-slate-600">Leads lost to unanswered calls</span>
                </div>
                <div className="bg-white px-6 py-4 rounded-xl shadow-sm border border-orange-200">
                  <span className="block text-3xl font-bold text-orange-600">100%</span>
                  <span className="text-sm text-slate-600">Response rate with AI agents</span>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-20">
            {automationFeatures.map((item, i) => (
              <div key={i} className="flex gap-6 p-8 rounded-2xl border border-slate-100 hover:border-orange-200 hover:shadow-lg transition-all">
                <div className="shrink-0 w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center text-white">
                  <SafeIcon icon={item.icon} className="text-2xl" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="max-w-4xl mx-auto">
            <AuditForm 
              type="Automation" 
              title="Calculate Your Missed Call Revenue" 
              subtitle="Let's analyze your current call volume and show you exactly how much revenue an AI receptionist will capture for your business."
              buttonText="Request Automation Demo"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default VoiceAutomation;